import { Quote } from '../types';
import Icon from '../../../components/AppIcon';

interface QuoteHeaderProps {
  quote: Quote;
}

const QuoteHeader = ({ quote }: QuoteHeaderProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const getStatusColor = (status: Quote['status']) => {
    switch (status) {
      case 'APPROVED':
        return 'bg-success/10 text-success';
      case 'CANCELLED':
        return 'bg-error/10 text-error';
      default:
        return 'bg-warning/10 text-warning';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-4">
            <h1 className="text-2xl font-semibold text-text-primary">
              {quote.projectName}
            </h1>
            <span
              className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
                quote.status
              )}`}
            >
              {quote.status}
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <Icon name="FileText" size={20} className="text-text-secondary mt-0.5" />
              <div>
                <p className="text-sm text-text-secondary">Reference Code</p>
                <p className="text-sm font-medium text-text-primary font-mono">
                  {quote.referenceCode}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Icon name="Calendar" size={20} className="text-text-secondary mt-0.5" />
              <div>
                <p className="text-sm text-text-secondary">Created Date</p>
                <p className="text-sm font-medium text-text-primary">
                  {formatDate(quote.createdDate)}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Icon name="Clock" size={20} className="text-text-secondary mt-0.5" />
              <div>
                <p className="text-sm text-text-secondary">Valid Until</p>
                <p className="text-sm font-medium text-text-primary">
                  {formatDate(quote.validUntil)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteHeader;